import React from "react";
import { useState, useEffect } from "react";
import Hero from "../Hero";
import AboutSection from "../Section/AboutSection";
import BrandsSection from "../Section/BrandsSection";
import axios from "axios";
import Banner from "../Section/BannerSection";
import BannerSectionStyle2 from "../Section/BannerSection/BannerSectionStyle2";
import Section from "../Section";
import FeaturesSection from "../Section/FeaturesSection";
import TestimonialSection from "../Section/TestimonialSection";
import BlogSection from "../Section/BlogSection";
import AppointmentSection from "../Section/AppointmentSection";
import FaqSection from "../Section/FaqSection";
import FaqSectionStyle3 from "../Section/FaqSection/FaqSectionStyle3";
import AwardSection from "../Section/AwardSection";
import DepartmentSectionStyle4 from "../Section/DepartmentSection/DepartmentSectionStyle4";
import PricingSection from "../Section/PricingSection";
import { pageTitle } from "../../helpers/PageTitle";
import AwardSectionStyle2 from "../Section/AwardSection/AwardSectionStyle2";
import { FaFileAlt, FaArrowRight } from "react-icons/fa";
import FeatherIcon, { AlignCenter } from "feather-icons-react";
import { RxCrossCircled } from "react-icons/rx";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { API_URL } from "../../Config/environment";
import { getAllBlogs } from "../../Api/blog";
import { Link } from "react-router-dom";
import { FaGlobe, FaPlaneDeparture } from "react-icons/fa";
import FaqSectionStyle4 from "../Section/FaqSection/FaqSectionStyle4";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { FaUserPlus } from "react-icons/fa";
import truncateString from "../../helpers/truncateString";
import MedicalServices from "../MedicalServices";
import HomeSearchBar from "../HomeSearchBar";
import { APP_URL } from "../../Config/environment";



const slides = [
    {
        title: "Top Doctors. Trusted & Verified.",
        cta: "Talk Now",
        img: "/images/header/doctor.png",
    },
    {
        title: "Book Lab Tests at a Discount",
        cta: "Book Now",
        img: "/images/header/blood-test.png",
    },
    {
        title: "Consult a Wellness Expert",
        cta: "Book Appointment Now",
        img: "/images/header/doctor-consultation.png",
    },
    {
        title: "Wellness Packages from Trusted Experts",
        cta: "Book Now",
        img: "/images/header/health-care.png",
    },
];

const services = [
    { name: "Pre-diabetic Care", icon: "/images/home_1/sugar-blood-level.png" },
    { name: "Weight Management", icon: "/images/home_1/weight-loss-scale.png" },
    { name: "Knee Replacement", icon: "/images/home_1/knee.png" },
    { name: "Cataract", icon: "/images/home_1/cataract.png" },
    { name: "General Wellness", icon: "/images/home_1/wellness-program.png" },
    { name: "Vaccination", icon: "/images/home_1/vaccine.png" },
    { name: "Therapy", icon: "/images/home_1/physical-therapy.png" },
    { name: "IVF", icon: "/images/home_1/ivf.png" },
    { name: "Fertility", icon: "/images/home_1/prenatal-care.png" },
    { name: "Sexual Wellness", icon: "/images/home_1/std.png" },
    { name: "Kidney Stones", icon: "/images/home_1/kidney.png" },
    { name: "Joint Replacement", icon: "/images/home_1/bone-joint.png" },
];

const featureListData = [
    {
        iconSrc: "/images/home_1/compassion.svg",
        title: "Healthcare Social Media",
        // subTitle:
        //   'We understand that seeking medical care can be a stressful and emotional experience, and we strive to create a welcoming and supportive environment that puts our patients at ease and every one.',
    },
    {
        iconSrc: "/images/home_1/excellence.svg",
        title: "Healthcare Insurance",
        // subTitle:
        //   'We are committed to providing excellent medical care and services to our patients. We believe in continuously improving our skills, knowledge, and resources to ensure that we deliver the highest quality care possible.',
    },
    {
        iconSrc: "/images/home_1/integrity.svg",
        title: "Easy Book Appointment",
        // subTitle: `We believe in practicing medicine with integrity and honesty. We are transparent in our communication and decision-making processes, and we always put our patient's interests first & provide best solution.`,
    },
    {
        iconSrc: "/images/home_1/respect.svg",
        title: "Express Support",
        // subTitle:
        //   'We treat all individuals with respect and dignity, regardless of their background, beliefs, or circumstances. We believe that every person deserves to be treated with compassion and kindness.',
    },
    // {
    //   iconSrc: '/images/home_1/teamwork.svg',
    //   title: 'Teamwork',
    //   subTitle:
    //     'We believe in working collaboratively with our team membersvand other healthcare professionals to provide comprehensive and effective care to our patients.',
    // },
];
const faqData = [
    {
        title: "How do I create an account on GKC Platform ?",
        content: `
      1. Visit the GKC Klinica Website
      2. Choose Doctor Registration.
      3. Fill in Required Information: mobile number, email ID, address, name, date of birth, specialization, and gender.
      4. Verify Your Account.
      5. Complete Your Profile.
    `,
    },
    {
        title: "What information do I need to provide to register on the GKC Klinica platform?",
        content:
            "To register, provide your mobile number, email ID, address, name, date of birth, specialization, and gender. Then complete your profile with education, registration number, location, achievements, awards, and OPD timing. For help, contact support@gkcklinica.com.",
    },
    {
        title: "How do I reset my password?",
        content:
            'Click "Forgot Password" on the login screen, enter your mobile/email, and use the received code to set a new password.',
    },
    {
        title: "Can I access my medical records on the app?",
        content:
            "Yes! GKC Klinica allows secure storage and access to prescriptions, lab results, and doctor notes (with permission).",
    },
    {
        title: "How do I schedule an appointment with a doctor?",
        content:
            "Search doctors by specialty and location, view their profiles, and book appointments in the app.",
    },
    {
        title: "Can I communicate with my doctor through the app?",
        content:
            "Absolutely! Secure messaging is available to connect with your doctor.",
    },
    {
        title: "How do I track my medical history and test results?",
        content:
            "The apps medical records section shows history including past consultations, prescriptions, and shared test results.",
    },
    {
        title: "Is my personal and medical information secure on the app?",
        content:
            "Yes, we use industry-standard security to protect your data and ensure confidentiality.",
    },
    {
        title: "How do I find a hospital or healthcare provider on the app?",
        content:
            "Use the search feature with filters like location, specialty, and rating.",
    },
    {
        title: "Can I search for hospitals by location or specialty?",
        content:
            "Yes, filter hospitals by location or their specialty (e.g., cardiology, pediatrics).",
    },
    {
        title: "How do I view hospital profiles and ratings?",
        content:
            "Each hospital profile shows services, location, and patient ratings.",
    },
    {
        title: "How do I access my medical records from a hospital?",
        content:
            "Doctors share records in the app. To access hospital-held records, contact the hospital directly.",
    },

    {
        title: "How do I provide feedback or review a hospital or doctor?",
        content:
            "Leave ratings and reviews for doctors through the platform to help others",
    },

    {
        title: "What services does the app offer?",
        content:
            "Doctor discovery, appointment booking, secure messaging, and medical record storage/access.",
    },

    {
        title: "Is the app free to use?",
        content:
            "Basic features are free. Consultations may incur fees depending on doctor and insurance.",
    },

    {
        title: "How do I contact customer support?",
        content: "Contact support through the app or via the website for help.",
    },

    {
        title: "Is my data secure and confidential?",
        content:
            "Yes, your data is encrypted and protected using industry best practices.",
    },

    {
        title: "How do I update my personal information?",
        content: "Go to the app’s settings and update your details easily.",
    },

    {
        title: "Can I use the app on multiple devices?",
        content: "Yes, sign in on any device with your credentials.",
    },

    {
        title: "How do I delete my account?",
        content:
            "Use app settings to delete your account. Note that all stored records will also be deleted.",
    },
];

const cardsimage = [
    {
        title: "Doctors",
        image: "/images/doctor.png",
        href: "#",
    },
    {
        title: "Hospitals",
        image: "/images/hospital.png",
        href: "#",
    },
    {
        title: "Labs",
        image: "/images/lab.png",
        href: "#",
    },
    {
        title: "Medicine",
        image: "/images/home_1/1019-08.jpg",
        href: "#",
    },
];

const departmentData = [
    {
        id: "cltquurty000108lbeyg26ewp",
        title: "Cardiologist",
        subTitle: "Heart health, hypertension management, and advanced cardiac diagnostic care.",
        iconUrl: "/images/home_2/department_icon_4.svg",
        href: "/departments/department-details",
    },
    {
        id: "cuj56sd5b000108l0f8xps1g7",
        title: "Dermatologist",
        subTitle: "Comprehensive skin, hair, and nail treatments with modern dermatological solutions.",
        iconUrl: "/images/home_1/skin.png",
        href: "/departments/department-details",
    },
    {
        id: "cuj56sd5b000b08l0fsdjj3mr",
        title: "ENT Specialist",
        subTitle: "Specialized care for ear, nose, throat, and head-neck related disorders.",
        iconUrl: "/images/home_1/audiologist.png",
        href: "/departments/department-details",
    },
    {
        id: "cuj56sd5b000208l0fvldywb7",
        title: "Endocrinologist",
        subTitle: "Managing hormonal imbalances, diabetes, and metabolic health efficiently.",
        iconUrl: "/images/home_1/endocrinology.png",
        href: "/departments/department-details",
    },
    {
        id: "cuj56sd5b000h08l0elv4qbzr",
        title: "OB/GYN",
        subTitle: "Expert care for women’s reproductive health, pregnancy, and childbirth.",
        iconUrl: "/images/home_2/department_icon_3.svg",
        href: "/departments/department-details",
    },
    {
        id: "cuj56sd5b000708l0g0e29t4k",
        title: "Neurologist",
        subTitle: "Diagnosis and treatment of complex brain and nervous system conditions.",
        iconUrl: "/images/home_2/department_icon_5.svg",
        href: "/departments/department-details",
    },
    {
        id: "cuj56sd5b001308l0g8s5czpx",
        title: "Urologist",
        subTitle: "Expert care for urinary tract health and the male reproductive system.",
        iconUrl: "/images/home_1/department_icon_1.svg",
        href: "/departments/department-details",
    },
    {
        id: "cuj56sd5b000a08l0fgwdpb7p",
        title: "Orthopedic Surgeon",
        subTitle: "Specialized surgical and non-surgical care for bone, joint, and muscle conditions.",
        iconUrl: "/images/home_1/arthritis.png",
        href: "/departments/department-details",
    },
    {
        id: "cuj56sd5b000c08l0ba6crb3b",
        title: "Pediatrician",
        subTitle: "Comprehensive and compassionate healthcare dedicated to infants, children, and adolescents.",
        iconUrl: "/images/home_2/department_icon_2.svg",
        href: "/departments/department-details",
    },
    {
        id: "cuj56sd5b001208l0g7s5czpu",
        title: "Physiotherapy",
        subTitle: "Physical rehabilitation and movement therapy to restore function after injury or surgery.",
        iconUrl: "/images/home_1/physiotherapy.png",
        href: "/departments/department-details",
    },
    {
        id: "cuj56sd5b001008l0g3bqhb3b",
        title: "Ayurveda",
        subTitle: "Traditional holistic healing focused on balancing body and mind for long-term wellness.",
        iconUrl: "/images/home_1/ayurveda.png",
        href: "/departments/department-details",
    },
    {
        id: "cuj56sd5b000z08l0djpmgvz4",
        title: "Homeopathy",
        subTitle: "Natural therapeutic treatments using a personalized approach to boost your body's healing.",
        iconUrl: "/images/home_1/homeopathy.png",
        href: "/departments/department-details",
    },
];


const doctorTestimonials = [
    {
        quote: "GKCKlinica simplifies the process by bringing services onto a single platform, making it easier for patients to submit and for doctors to review reports and provide timely prescriptions.",
        name: "Dr. Surbhi Bansal Agrawal",
        designation: "General Physician and Diabetologist",
        imgUrl: "/images/about/doctor_3.png"
    },
    {
        quote: "I see GKC Klinica as a bridge between experienced, verified orthopedic specialists and the many patients worldwide who are uncertain about whom to consult.",
        name: "Dr. Kiran Saoji",
        designation: "Orthopedic Specialist",
        imgUrl: "/images/about/doctor_3.png"
    },
    {
        quote: "Platforms like GKC Klinica help patients identify and connect with verified eye care professionals on time, supporting better long-term eye health outcomes.",
        name: "Dr. Ajit Sinha",
        designation: "Eye Specialist",
        imgUrl: "/images/about/doctor_3.png"
    }
];



export default function Home() {
    const [showModal, setShowModal] = useState(false);
    const [blogData, setBlogData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [packages, setPackages] = useState([]);
    const [insuranceData, setInsuranceData] = useState([]);
    const [memberships, setMemberships] = useState([]);
    const [showPromo, setShowPromo] = useState(true);
    const [promoData, setPromoData] = useState(null);
    const images = [
        "/images/about/slider1.jpeg",
        "/images/about/slider2.jpeg",
        "/images/about/slider3.jpeg",
    ];



    // Autoplay plugin
    const autoplay = (slider) => {
        let timeout;
        let mouseOver = false;

        function clearNextTimeout() {
            clearTimeout(timeout);
        }

        function nextTimeout() {
            clearTimeout(timeout);
            if (mouseOver) return;
            timeout = setTimeout(() => {
                slider.next();
            }, 3000);
        }

        slider.on("created", () => {
            slider.container.addEventListener("mouseover", () => {
                mouseOver = true;
                clearNextTimeout();
            });
            slider.container.addEventListener("mouseout", () => {
                mouseOver = false;
                nextTimeout();
            });
            nextTimeout();
        });

        slider.on("dragStarted", clearNextTimeout);
        slider.on("animationEnded", nextTimeout);
        slider.on("updated", nextTimeout);
    };

    const [sliderRef] = useKeenSlider(
        {
            loop: true,
            slides: {
                perView: 1, // one slide visible at a time
                spacing: 0, // no gap between slides
            },
        },
        [autoplay]
    );

    function mapToPostItems(apiBlogs) {
        return apiBlogs.map((blog) => ({
            title: blog.title,
            thumbUrl: `${API_URL}/uploads/blogs/${blog.imageUrl[0]}`,
            date: new Date(blog.createdAt).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "2-digit",
            }),
            btnText: "Read more",
            href: `/blog/${blog.id}`,
            socialShare: true,
        }));
    }

    useEffect(() => {
        async function fetchBlogs() {
            try {
                setLoading(true);
                const apiBlogs = await getAllBlogs(); // await works here
                // const newmap = mapToPostItems(apiBlogs.blogs);
                // const result = newmap.slice(0, 6);
                setBlogData(apiBlogs.blogs);
            } catch (err) {
                console.error("Error fetching blogs:", err);
            } finally {
                setLoading(false);
            }
        }

        fetchBlogs();
    }, []);

    const getInsurenceData = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${API_URL}/insurance-policy/home?page=1&limit=4`
            );
            if (response?.data?.statusCode === 200) {
                setInsuranceData(response.data?.data?.policies);
            } else {
                console.warn("Unexpected API response:", response.data);
            }
        } catch (error) {
            console.error("Error fetching policies:", error);
        } finally {
            setLoading(false);
        }
    };

    const getHealthPackage = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${API_URL}/health-package/home-page?page=1&limit=4`
            );
            if (response?.data?.statusCode === 200) {
                setPackages(response.data?.data?.packages);
            } else {
                console.warn("Unexpected API response:", response.data);
            }
        } catch (error) {
            console.error("Error fetching health packages:", error);
        } finally {
            setLoading(false);
        }
    };

    const getMembershipData = async () => {
        try {
            const response = await axios.get(
                `${API_URL}/user/membership/plan?category=&page=1&limit=3`
            );
            if (response?.data?.statusCode === 200) {
                setMemberships(response.data?.data?.membership_plans || []);
            }
        } catch (error) {
            console.error("Error fetching memberships:", error);
        }
    };

    useEffect(() => {
        const fetchBanner = async () => {
            try {
                const response = await axios.get(
                    `${API_URL}/admin/banner/uploads/home-page`
                );

                if (response?.data?.statusCode === 200) {
                    const firstBanner = response.data?.data?.banners?.[0];

                    if (firstBanner) {
                        setPromoData({
                            title: firstBanner.title,
                            subtitle: firstBanner.subtitle,
                            description: firstBanner.description,
                            image: firstBanner.bannerUrl,
                            ctaText: firstBanner.ctaText,
                            ctaLink: firstBanner.ctaLink,
                        });
                    }
                } else {
                    console.warn("Unexpected banner response:", response.data);
                }
            } catch (error) {
                console.error("Error fetching banner:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchBanner();
    }, []);

    useEffect(() => {
        getHealthPackage();
        getInsurenceData();
        getMembershipData();
    }, []);

    useEffect(() => {
        const lastShown = localStorage.getItem("promo_last_shown");
        const now = new Date().getTime();

        const SIX_HOURS = 6 * 60 * 60 * 1000;

        if (!lastShown || now - lastShown > SIX_HOURS) {
            setTimeout(() => {
                setShowPromo(true);
                localStorage.setItem("promo_last_shown", now);
            }, 3000);
        }
    }, []);


    const [current, setCurrent] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrent((prev) => (prev + 1) % slides.length);
        }, 3000);

        return () => clearInterval(interval);
    }, []);


    if (loading) return <p>Loading...</p>;

    pageTitle("Home");

    return (
        <>

            {/* <Example/> */}
            <Hero
                title="Instantly Consult the Best Doctors for Your Concern"
                subTitle="Personalized Care. Proven Excellence."
                bgUrl="/images/home_1/hero_bg.jpeg"
                imgUrl="/images/model.png"
                videoBtnText="See How To Install App"
                videoUrl="https://www.youtube.com/embed/ArnHiPWX278"
                infoList={[
                    {
                        title: "Hotline",
                        subTitle: "+91-9766833510",
                        iconUrl: "/images/contact/icon_1.svg",
                    },
                    {
                        title: "Ambulance",
                        subTitle: "+91-9766833510",
                        iconUrl: "/images/icons/ambulance.svg",
                    },
                    {
                        title: "Location",
                        subTitle: "Nagpur - India",
                        iconUrl: "/images/icons/pin.svg",
                    },
                ]}
                btnText="Book Now"
                btnUrl="https://app.gkcklinica.com/login"


            >
                {/* <div className="cs_hero_box">
    <span className="cs_hero_text">
      Top Doctors just for you
    </span>

    <Link
      to="https://app.gkcklinica.com/login"
      className="cs_hero_btn"
    >
      Book Consultation →
    </Link>
  </div> */}
            </Hero>


            {/* <Section
        topMd={190}
        topLg={145}
        topXl={105}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <AwardSectionStyle2
          sectionTitle="Winning Awards and <br />Recognition"
          sectionTitleUp="AWARDS"
          sectionSubTitle="We have been recognized for our commitment to <br />excellence in healthcare."
          data={awardData}
        />
      </Section> */}
            <Section
         top={100}
             topMd={140}
           

            >
                <HomeSearchBar />
            </Section>

            <Section
            >
                <div className="promo-carousel" >
                    {slides.map((slide, index) => (
                        <div
                            key={index}
                            className={`promo-slide ${index === current ? "active" : ""
                                }`}
                        >
                            {/* LEFT TEXT */}
                            <div className="promo-content">
                                <h2>{slide.title}</h2>

                                <Link to={APP_URL} className="promo-btn">
                                    {slide.cta} →
                                </Link>
                            </div>

                            {/* RIGHT IMAGE */}
                            <div className="promo-image">
                                <img src={slide.img} alt="banner" style={{ width: "150px", marginRight: "100px" }} />
                            </div>
                        </div>
                    ))}

                    {/* Dots */}
                    <div className="promo-dots">
                        {slides.map((_, i) => (
                            <span
                                key={i}
                                className={i === current ? "active" : ""}
                                onClick={() => setCurrent(i)}
                            />
                        ))}
                    </div>
                </div>

            </Section>

            <Section topMd={80}
                topLg={80}
                topXl={80}>
                <div className="cashless-container">

                    <h2 className="dept-title">
                        Consult GKC’s Specialists for
                    </h2>

                    <p className="section-subtext">
                        Planning your health requires expert guidance and proper financial planning.
                        Get in touch with GKC’s Experts for proper advice with a few clicks.
                    </p>

                    <div className="service-grid">
                        {services.map((item, index) => (
                            <div className="service-item" key={index} onClick={() => {
                                window.location.href = "https://app.gkcklinica.com/public-profiles";
                            }}>
                                <div className="icon-wrapper">
                                    <div className="icon-bg">
                                        <div className="iconn">
                                            <img src={item.icon} alt={item.name} />
                                        </div>
                                    </div>
                                </div>
                                <span>{item.name}</span> {/* ✅ FIX HERE */}
                            </div>
                        ))}
                    </div>

                </div>
            </Section>
            {/* 2. Professional Services Grid */}
            <MedicalServices />
            {/* 
            <section className="image-overlay-section">
                <div className="container">

                    <div className="card-grid">
                        {cardsimage.map((card, idx) => (
                            <a
                                href={card.href}
                                className="image-overlay-card"
                                key={idx}
                            >
                                <img
                                    src={card.image}
                                    alt={card.title}
                                    className="card-img"
                                />
                                <div className="overlay">
                                    <h2 className="title">{card.title}</h2>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
            </section> */}

            {/* <Section>
                <Banner
                    bgUrl="images/home_1/cta_bg.svg"
                    // imgUrl="images/healthBanner3.jpg"
                    title="Booked Health Packages"
                    subTitle="Explore trusted health checkups for wellness and early diagnosis"
                />
            </Section> */}

            <div className="health-banner">
                <img src="/images/about/health-package.png" />
            </div>

            {/* <Section>
              <BannerSectionStyle2
                bgUrl="/images/healthBanner3.jpg"
                title="Don’t Let Your Health Take a Backseat!"
                subTitle="Schedule an appointment with one of our <br />
                experienced medical professionals today!"
              />
            </Section> */}
            {/* Start Feature Section */}

            {/* End Feature Section */}
            {/* Start About Section */}
            {/* <Section>
        <AboutSection
          imgUrl="/images/home_1/about.png"
          spiningImgUrl="/images/home_1/about_mini.svg"
          title="About Us"
          subTitle="Gkc Klinica"
          featureList={[
            {
              featureListTitle:
                'Empowering Your Well-being Journey, on a Global Scale',
              featureListSubTitle:
                'GKC Klinica is a comprehensive healthcare platform dedicated to providing accessible, high-quality medical care, with a vision to expand our reach and revolutionize healthcare delivery on a global level. We leverage technology to connect you with a network of qualified healthcare professionals, making it easier than ever to manage your health and wellness, no matter where you are in the world.',
            },
          ]}
        />
      </Section> */}

            <Section
                topMd={100}
                topLg={100}
                topXl={100}
            // bottomMd={80}
            // bottomLg={150}
            // bottomXl={110}
            >
                <div className="container">
                    {/* Header with "Show More" */}
                    <div className="d-flex justify-content-between align-items-center mb-5 flex-wrap gap-3">
                        <h2 className="dept-title mb-0">Popular Health Packages</h2>
                        <Link
                            to="/pricing-plan"
                            className="btn rounded-pill fw-semibold shadow-sm px-4"
                            style={{ backgroundColor: "#0ea5e9", color: "white" }}
                        >
                            Show more
                        </Link>
                    </div>

                    <div className="row g-4 justify-content-center">
                        {packages.map((pack) => (
                            /* col-12: 1 per row on mobile
                               col-md-6: 2 per row on tablets
                               col-lg-3: 4 per row on desktop 
                            */
                            <div key={pack.id} className="col-12 col-md-6 col-lg-3">
                                <div className="plan-card h-100 d-flex flex-column">
                                    <div className="plan-card-header">
                                        {/* Handles long names with a tooltip for the full name */}
                                        <h2 className="package-name" title={pack.name}>
                                            {pack.name}
                                        </h2>
                                        <span className="package-subtitle">Includes lab & diagnostic tests</span>
                                    </div>

                                    <div className="etiquet-price mt-3">
                                        <p>{pack.price}</p>
                                        <div className="ribbon-fold"></div>
                                    </div>

                                    <div className="benefits-list flex-grow-1">
                                        <ul className="list-unstyled mt-3">
                                            <li>🧪 {pack.testCounts} Tests Included</li>
                                            <li>
                                                <FaFileAlt className="me-2" size={14} />
                                                <span>Reports: <strong>{pack.duration || "N/A"}</strong></span>
                                            </li>
                                            <li className="discount-tag">{pack.discount}% OFF</li>
                                        </ul>
                                    </div>

                                    <div className="button-get-plan mt-auto">
                                        <Link to={`/packages/${pack.id}`} className="book-btn">
                                            <span>Book Now</span>
                                            <FaArrowRight className="ms-2" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </Section>

            {/* <Section>
                <Banner
                    bgUrl="images/home_1/cta_bg.svg"
                    title="Insurance policy"
                    subTitle="Your safety matters—explore curated insurance plans for every life stage"
                />
                <div className="health-banner">
                    <img src="/images/about/2 (1).png" />
                </div>
            </Section> */}

            {/* <Section
                topMd={185}
                topLg={140}
                topXl={100}
                bottomMd={200}
                bottomLg={150}
                bottomXl={110}
            >
                <div className="d-flex justify-content-end mb-4 pe-4">
                    <Link
                        to="https://app.gkcklinica.com/login?insurance=true"
                        className="btn rounded-pill fw-semibold shadow-sm"
                        style={{
                            backgroundColor: "#0ea5e9",
                            color: "white",
                            padding: "6px 18px",
                        }}
                    >
                        Show more
                    </Link>
                </div>
                <div className="container py-4">
                    <div className="row justify-content-center">
                        {insuranceData.map((pack) => (
                            <div
                                key={pack.id}
                                className="col-md-6 col-lg-3 mb-4 d-flex justify-content-center"
                            >
                                <div className="insurance-card">
                                    <div className="insurance-card__shine"></div>
                                    <div className="insurance-card__glow"></div>
                                    <div className="insurance-card__content">
                                    
                                        <div className="insurance-card__badge">
                                            Recommended
                                        </div>

                                     
                                        <div
                                            style={{ "--bg-color": "#a78bfa" }}
                                            className="insurance-card__image"
                                        >
                                            <img
                                                src="/images/slide4.png"
                                                alt=""
                                                srcSet=""
                                            />
                                        </div>

                                        <div className="insurance-card__text">
                                            <p className="insurance-card__title">
                                                {pack.policyName}
                                            </p>
                                            <p
                                                className="insurance-card__description"
                                                style={{ fontWeight: "600" }}
                                            >
                                                {pack.insuranceProvider}
                                            </p>
                                            <p className="insurance-card__description">
                                                {truncateString(
                                                    15,
                                                    pack.description
                                                )}
                                            </p>
                                        </div>

                                  
                                        <div className="insurance-card__footer">
                                            <div className="insurance-card__price">
                                                Coverage: {pack.coverage} <br />
                                                Premium: {pack.premium} <br />
                                                Tenure: {pack.tenure}
                                            </div>
                                            <a
                                                href={`${API_URL}/${pack.fileUrl}`}
                                                className="insurance-card__button"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <FeatherIcon
                                                    icon="file-text"
                                                    size="14"
                                                />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </Section> */}




            <Section
                topMd={100}
                topLg={100}
                topXl={100}
                bottomMd={100}
                bottomLg={100}
                bottomXl={100}
            >
                <div className="insurance-wrapper container">

                    {/* Top Right Button (UNCHANGED LINK) */}
                    <div className="d-flex justify-content-end pe-2">
                        <Link
                            to="https://app.gkcklinica.com/login?insurance=true"
                            className="insurance-btn"
                        >
                            Show more
                        </Link>
                    </div>

                    {/* Heading */}
                    <div className="dept-heading">
                        <h2 className="dept-title">Insurance</h2>

                        <p className="insurance-subtext">
                            Access all your health insurance services in one place with GKC Klinica -
                            view policy details, start and track claims, avail cashless treatment at
                            network hospitals, and notify hospitalization instantly.
                        </p>
                    </div>

                    {/* Cards */}
                    <div className="insurance-grid">

                        <div className="insurance-box">
                            <div className="insurance-head">
                                <span>Loyalty Benefits</span>
                                <span className="arrow">→</span>
                            </div>
                            <p>Exclusive benefits for our Members.</p>
                            <img src="/images/home_1/loyal-customer.png" alt="" />
                        </div>

                        <div className="insurance-box">
                            <div className="insurance-head">
                                <span>Hassle-Free Claims</span>
                                <span className="arrow">→</span>
                            </div>
                            <p>Easy tracker</p>
                            <img src="/images/home_1/claim.png" alt="" />
                        </div>

                        <div className="insurance-box">
                            <div className="insurance-head">
                                <span>Network Hospitals</span>
                                <span className="arrow">→</span>
                            </div>
                            <p>Find the closest cashless hospital covered by your insurance plan</p>
                            <img src="/images/home_1/hospital.png" alt="" />
                        </div>

                        <div className="insurance-box">
                            <div className="insurance-head">
                                <span>Customer Care</span>
                                <span className="arrow">→</span>
                            </div>
                            <p>Get in touch with GKC’s Support Team</p>
                            <img src="/images/home_1/customer-service.png" alt="" />
                        </div>

                    </div>

                </div>
            </Section>

            <div className="health-banner2" style={{ marginBottom: "10%" }}>
                <img src="images/about/blooddonation.png" />
                <Link
                    to="https://app.gkcklinica.com/login"
                    className="book-now-btn1 overlay-btn"
                >
                    <FaUserPlus className="icon" />
                    Register
                </Link>
            </div>

            {/* End About Section */}
            {/* Start Departments Section */}

            <div className="dept-heading">
                {/* <h4 className="dept-subtitle">CHOOSE Your</h4> */}
                <h2 className="dept-title"> Membership Plan</h2>
            </div>
            <Section
            // topMd={185}
            // topLg={140}
            // topXl={100}
            // bottomMd={185}
            // bottomLg={140}
            // bottomXl={100}
            >
                <div
                    style={{ maxWidth: "1140px", margin: "0 auto" }}
                    className="mb-3 d-flex justify-content-end"
                >
                    <button
                        className="btn btn-primary rounded-pill px-4 fw-semibold shadow-sm"
                        style={{
                            backgroundColor: "#0ea5e9",
                            marginBottom: "30px",
                        }}
                        onClick={() => setShowModal(true)}
                    >
                        Join Now <FaArrowRight size={14} />
                    </button>
                </div>

                {/* Modal */}
                {showModal && (
                    <div
                        className="modal fade show d-block"
                        tabIndex="-1"
                        role="dialog"
                        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                        onClick={() => setShowModal(false)}
                    >
                        <div
                            className="modal-dialog modal-dialog-centered"
                            role="document"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="modal-content p-4 rounded-4 shadow-lg border-0 membership-modal">
                                <button
                                    type="button"
                                    className="btn-close ms-auto"
                                    onClick={() => setShowModal(false)}
                                ></button>
                                <h5 className="fw-bold mb-4 text-center membership-title">
                                    Select Membership Type
                                </h5>
                                <div className="d-grid gap-3">
                                    <Link
                                        to="/membership"
                                        className="btn membership-btn"
                                    >
                                        <FaGlobe className="icon" /> National
                                        Membership
                                    </Link>
                                    <Link
                                        to="/membership"
                                        className="btn membership-btn"
                                    >
                                        <FaPlaneDeparture className="icon" />{" "}
                                        International Membership
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <div className="row g-4 justify-content-center">
                    {memberships.map((pack) => {
                        const discountPercent = Math.round(
                            ((pack.price - pack.discountPrice) / pack.price) *
                            100
                        );

                        return (
                            //
                            <div
                                key={pack.id}
                                className="col-auto d-flex justify-content-center"
                            >
                                <div className="pricing-card">
                                    <div className="pricing-card__content">
                                        {/* Price Tag */}
                                        <span className="pricing-card__price">
                                            ₹{pack.discountPrice}{" "}
                                            <small>/ plan</small>
                                        </span>

                                        {/* Plan Name */}
                                        <p className="pricing-card__title">
                                            {pack.name}
                                        </p>
                                        <p className="pricing-card__description">
                                            {pack.description}
                                        </p>

                                        {/* Features */}
                                        <ul className="pricing-card__features">
                                            {Object.entries(pack.features).map(
                                                ([feature, has]) => (
                                                    <li key={feature}>
                                                        {has ? (
                                                            <IoCheckmarkCircleOutline className="icon" />
                                                        ) : (
                                                            <RxCrossCircled className="icon cross" />
                                                        )}
                                                        <span>{feature}</span>
                                                    </li>
                                                )
                                            )}
                                        </ul>

                                        {/* Bottom CTA */}
                                        <div className="pricing-card__action">
                                            <Link
                                                to="/membership"
                                                className="btn-choose"
                                            >
                                                Choose Plan
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </Section>
            <Section topMd={80}
                topLg={80}
                topXl={80}
                bottomMd={80}
                bottomLg={80}
                bottomXl={80}>
                <div className="health-banner2">
                    <img src="images/about/yogateacher.png" />
                    <Link
                        to="https://app.gkcklinica.com/login"
                        className="book-now-btn1 overlay-btn"
                    >
                        Register
                    </Link>
                </div></Section>

            <Section
            // bottomMd={125} bottomLg={125} bottomXl={85}
            >
                <DepartmentSectionStyle4
                    sectionTitle="Care Team "
                    // sectionTitleUp="Our Specialized "
                    data={departmentData}
                />
            </Section>

            {/* <Section>
        <Banner
          bgUrl="images/home_1/cta_bg.svg"
          imgUrl="images/about/blooddonation.png"
          title="Insurance policy"
          subTitle="Your safety matters—explore curated insurance plans for every life stage"
        />
      </Section> */}

            <Section
                topMd={100}
                topLg={100}
                topXl={100}
                bottomMd={100}
                bottomLg={100}
                bottomXl={100}
            >
                <div className="dept-heading">
                    {/* <h4 className="dept-subtitle">CHOOSE Your</h4> */}
                    <h2 className="dept-title"> Periods & Pregnancy</h2>
                </div>

                <div className="health-banner2">
                    <img src="images/about/period-preg.png" />
                    <Link
                        to="https://app.gkcklinica.com/login"
                        className="book-now-btn1 overlay-btn"
                    >
                        Track
                    </Link>
                </div>
            </Section>

            {/* DOCTOR TESTIMONIALS - Grid Pattern */}
            {/* <Section bottomMd={125} bottomLg={125} bottomXl={85} topMd={50}>
                <div className="container">
                    <div className="text-center mb-5">
                        <h3 className="cs_section_subtitle">TESTIMONIALS</h3>

                    </div>
                    <div className="row">
                        <div className="row">
                            {doctorTestimonials.map((item, index) => (
                                <div className="col-lg-4 col-md-6 mb-4" key={index}>

                                    <div className="cs_testimonial_card p-4 shadow-sm border rounded-4 h-100 d-flex flex-column justify-content-between">

                                        <div className="cs_testimonial_top">

                                            <p className="cs_testimonial_quote mb-4 text-muted" style={{ fontStyle: 'italic', lineHeight: '1.6' }}>
                                                "{item.quote}"
                                            </p>
                                        </div>

                                        <div className="cs_testimonial_footer d-flex align-items-center mt-auto pt-3 border-top">

                                            <div className="cs_testimonial_avatar flex-shrink-0">
                                                <img
                                                    src={item.imgUrl || '/images/default-doctor.png'}
                                                    alt={item.name}
                                                    className="rounded-circle"
                                                    style={{ width: '60px', height: '60px', objectFit: 'cover', border: '2px solid #f0f0f0' }}
                                                />
                                            </div>

                                            <div className="ms-3">
                                                <h5 className="mb-1 fw-bold" style={{ fontSize: '1.1rem', color: '#333' }}>
                                                    {item.name}
                                                </h5>

                                                <span
                                                    className="text-primary d-block lh-sm"
                                                    style={{ fontSize: '0.85rem', fontWeight: '500', maxWidth: '200px' }}
                                                >
                                                    {item.designation}
                                                </span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </Section> */}




            {/* blog section  */}

            {/* <Section topMd={190} topLg={145} topXl={105}>
                <BlogSection
                    sectionTitle="Latest Update"
                    sectionTitleUp="BLOG POSTS"
                    sectionTitleDown=""
                    sectionSubTitle=""
                    data={blogData}
                />
            </Section> */}


            {/* End Departments Section */}
            {/* Start Award Section */}
            {/* <Section topMd={185} topLg={140} topXl={100}>
        <AwardSection sectionTitle="Departments" data={awardData} />
      </Section> */}
            {/* End Award Section */}
            {/* Start Testimonial */}
            {/* <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <TestimonialSection
          sectionTitle="Some Reviews"
          sectionTitleDown="Of our clients"
        />
      </Section> */}
            {/* End Testimonial */}
            {/* Start Banner Section */}
            <Section
                bottomMd={100}
                bottomLg={100}
                bottomXl={100}
            >
                <div className="app-banner premium-banner">

                    <div className="app-banner-content">
                        <p className="app-banner-text">
                            Reclaiming your health doesn’t require a big change — just a return to the basics.
                            Move more. Eat better. Stay hydrated. #ReclaimYourHealth
                        </p>

                        <h4 className="app-download-title">Download The App</h4>

                        <div className="app-buttons">
                            <a
                                href="https://play.google.com/store/apps/details?id=com.gkcklinica.GkcKlinica&hl=en_IN"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src="/images/g-play-btn.png" alt="Google Play" />
                            </a>

                            <a
                                href="https://apps.apple.com/in/app/gkc-klinica/id6670213393"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src="/images/ios-btn.png" alt="App Store" />
                            </a>
                        </div>
                    </div>

                    <div className="app-banner-image">
                        <img src="/images/header/gkcklinica1.jpg" alt="Health Banner" />
                    </div>

                </div>
            </Section>
            <Section
                bottomMd={100}
                bottomLg={100}
                bottomXl={100}
            >
                <div className="health-banner1">
                    <div ref={sliderRef} className="keen-slider">
                        {images.map((src, idx) => (
                            <div className="keen-slider__slide" key={idx}>
                                <img src={src} alt={`Slide ${idx + 1}`} />
                            </div>
                        ))}
                    </div>
                </div>
            </Section>

            <div className="wellness-banner">

                {/* LEFT ICON */}
                <div className="wellness-icon">
                    <img src="/images/header/hygiene.png" alt="Wellness" />
                </div>

                {/* CENTER CONTENT */}
                <div className="wellness-content">
                    <h4>Book a custom-designed wellness plan just for you.</h4>
                    <p>
                        Doctor and Nutrition recommended wellness plans designed for your health based on your lifestyle.
                    </p>
                </div>

                {/* RIGHT CTA */}
                <div className="wellness-cta">
                    <button onClick={() => (window.location.href = "/pricing-plan")}>Book Now</button>
                </div>

            </div>

            <div className="surgery-banner">

                {/* LEFT ICON */}
                <div className="surgery-icon">
                    <img src="/images/home_1/anxiety.png" alt="Surgery Help" />
                </div>

                {/* TEXT */}
                <div className="surgery-content">
                    <h4>Worried About Surgery, Specialist, Cost, or Facilities?</h4>
                    <p>
                        GKC is here to help you simplify the entire process.
                    </p>
                </div>

                {/* CTA */}
                <div className="surgery-cta">
                    <button onClick={() => (window.location.href = "https://app.gkcklinica.com/public-profiles")}>Consult Now</button>
                </div>

            </div>
            {/* End Banner Section */}
            {/* Start Blog Section */}
            {/* Feature section  */}

            {/* <Section
                topMd={185}
                topLg={140}
                topXl={100}
                bottomMd={185}
                bottomLg={140}
                bottomXl={100}
            >
                <FeaturesSection
                    sectionTitle="Feature"
                    data={featureListData}
                />
            </Section> */}

            {/* End Blog Section */}

            {/* <Section topMd={190} topLg={145} topXl={105}>
           <BlogSection
             sectionTitle="Latest Update"
             sectionTitleUp="BLOG POSTS"
             sectionTitleDown=""
             sectionSubTitle=""
             data={blogData}
           />
         </Section>  */}

            {/* Start Appointment Section */}
            {/* <Section topMd={190} topLg={145} topXl={105} id="appointment">
        <AppointmentSection
          sectionTitle="Appointment"
          sectionTitleUp="BOOK AN"
          imgUrl="/images/home_1/appointment.jpeg"
        />
      </Section> */}

            {/* End Appointment Section */}
            {/* Start FAQ Section */}

            {/* <Section topMd={190} topLg={145} topXl={105}>
                <FaqSectionStyle3
                    data={faqData}
                    sectionTitle="Usually Asked"
                    sectionTitleUp="What People"
                    sectionTitleDown=""
                    sectionSubTitle=""
                />
            </Section> */}

            {/* End FAQ Section */}
            {/* Start Brand Section */}

            <Section
            // topMd={200}
            // topLg={150}
            // topXl={110}
            // bottomMd={200}
            // bottomLg={150}
            // bottomXl={110}
            >
                <div className="gkc-promo-cards">

                    {/* BOX 1 */}
                    <div className="gkc-card gkc-card-green">
                        <div className="gkc-card-content">
                            <h4>Book your wellness journey now!</h4>
                            <p>
                                GKC offers Doctor recommended wellness package just for you.
                            </p>

                            <button onClick={() => (window.location.href = "/pricing-plan")}>Book Now →</button>
                        </div>

                        <div className="gkc-card-illustration">
                            <img src="/images/header/promo1.png" alt="Wellness" />
                        </div>
                    </div>

                    {/* BOX 2 */}
                    <div className="gkc-card gkc-card-blue">
                        <div className="gkc-card-content">
                            <h4>Consult a Surgeon Right now!</h4>
                            <p>
                                GKC offers surgery-related consultations with Expert Surgeons.
                            </p>

                            <button onClick={() => (window.location.href = "https://app.gkcklinica.com/public-profiles")}>Consult Now →</button>
                        </div>

                        <div className="gkc-card-illustration">
                            <img src="/images/header/promo2.png" alt="Surgery" />
                        </div>
                    </div>

                </div>
            </Section>


            {/* <Section
                topMd={200}
                topLg={150}
                topXl={110}
                bottomMd={200}
                bottomLg={150}
                bottomXl={110}
            >
                <BrandsSection data={brandData} />
            </Section> */}
            {/* End Brand Section */}
            {showPromo && promoData && (
                <div className="promo-popup">
                    {/* Close */}
                    <button
                        className="close-btn"
                        onClick={() => setShowPromo(false)}
                    >
                        ✕
                    </button>

                    {/* Image Section */}
                    <div className="promo-img-wrapper">
                        <img src={promoData?.image} alt="promo" />
                    </div>

                    {/* Content */}
                    <div className="promo-content">
                        <h4>{promoData?.title}</h4>
                        <h6>{promoData?.subtitle}</h6>
                        <p>{promoData?.description}</p>

                        <Link
                            to={promoData?.ctaLink || "#"}
                            className="promo-btn"
                            onClick={() => setShowPromo(false)}
                        >
                            {promoData?.ctaText || "Learn More"} →
                        </Link>
                    </div>
                </div>
            )}
        </>
    );
}
